import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

var TimestampManager = /*#__PURE__*/_createClass(function TimestampManager() {
  var _this = this;

  _classCallCheck(this, TimestampManager);

  this.observers = [];
  this.lastTaskID = 0;
  this.timer = null;

  this.startTicking = function () {
    if (_this.timer === null) {
      _this.timer = setInterval(_this._tickHandler, 1000);
    }
  };

  this.stopTicking = function () {
    if (_this.timer) {
      clearInterval(_this.timer);
      _this.timer = null;
    }
  };

  this._tickHandler = function () {
    var now = Date.now();

    for (var i = 0; i < _this.observers.length; i++) {
      var ob = _this.observers[i];

      if (now >= ob.timestamp) {
        ob.callback();

        _this.observers.splice(i, 1);
      }
    }
  };

  this.register = function (timestamp, callback) {
    var millis = 0;

    if (timestamp.constructor.name === 'Date') {
      millis = timestamp.getTime();
    } else {
      millis = Date.now() + timestamp;
    }

    var taskId = _this.lastTaskID + 1;

    _this.observers.push({
      id: taskId,
      timestamp: millis,
      callback: callback
    });

    return taskId;
  };

  this.unregister = function (id) {
    for (var i = 0; i < _this.observers.length; i++) {
      var ob = _this.observers[i];

      if (ob.id === id) {
        _this.observers.splice(i, 1);

        break;
      }
    }
  };
});

export var normalizeTimestamp = function normalizeTimestamp(timestamp) {
  return timestamp * 1000;
};
export var validateTimestamp = function validateTimestamp(endTimestamp) {
  return normalizeTimestamp(endTimestamp) - new Date().valueOf() >= 0;
};
export var getTimestamp = function getTimestamp(endTimestamp) {
  return normalizeTimestamp(endTimestamp) - new Date().valueOf() + 1000;
};
export var counterTypes = {
  SNEAK_PEEK: 'SNEAK_PEEK',
  MISSION_CARD: 'MISSION_CARD',
  MISSION_GRAND_CARD: 'MISSION_GRAND_CARD'
};
export var eventGraceTimeInMs = 7200000; // 2(hour) * 60(min) * 60(sec) * 1000(ms) = 7200000

var timestampManager = new TimestampManager();
export default timestampManager;